import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import CommonComponent from "../components/common/commonComponent.jsx";
import { setPath, setFiles, setLabels, updateLabelStatus, updateUploadStatusThroughEmail, setSelectedLabels } from "../actions/homeActions";
import { sendRequest } from "../util/httpRequest";
// import { apiRenamer } from "../util/genericFunctions";
import { HTTP_METHODS } from "../constants/enums";
import {API_URLS} from "../constants/API_URLS";

const CommonContainer = (props) =>
    <CommonComponent {...props} />

const mapStateToProps = (state) => ({
  files: state.file.files || [],
  allLabels: state.home.allLabels || [],
  selectedLabels: state.home.selectedLabels || [],
  filePath: state.home.filePath || "",
  path: state.home.path || "",
  user: state.auth.user || {},
  hasDocumentTypeChange: state.home.hasDocumentTypeChange || false,
})

const mapDispatchToProps = (dispatch, props) => ({
  setPathName: function (path) {
    dispatch(setPath(path))
  },
  clearFiles: function () {
    dispatch(setFiles([]))
  },
  updateFiles: function (files) {
    dispatch(setFiles(files))
  },
  addLabel: function (labels, path, response, error) {
    let option = {}
    option.headers = {}
    // var addLabelUrl = apiRenamer(API_URLS.ADD_LABEL_URL, ["path", "label"], [path, label]);
    sendRequest(API_URLS.ADD_LABEL, HTTP_METHODS.POST, { path, labels }, option, (err, res) => {
      if (err === null) {
        response(labels)
      } else {
        error(err)
      }
    })
  },
  removeLabel: function (label, path, response) {
    let option = {}
    option.headers = {}
    // var addLabelUrl = apiRenamer(API_URLS.REMOVE_LABEL_URL, ["path", "label"], [path, label]);
    sendRequest(API_URLS.REMOVE_LABEL, HTTP_METHODS.POST, { path, label }, option, (err, res) => {
      if (err === null) {
        response(label)
      } else {
        // error(err);
      }
    })
  },
  setLabels: function (allLabels) {
    dispatch(setLabels(allLabels))
  },
  setSelectedLabels: function (labels) {
    dispatch(setSelectedLabels(labels))
  },
  updateLabelStatus: function (isLabelUpdated) {
    dispatch(updateLabelStatus(isLabelUpdated))
  },
  updateUploadStatusThroughEmail: function (isEmailDocumentUpload) {
    dispatch(updateUploadStatusThroughEmail(isEmailDocumentUpload))
  },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CommonContainer))
